import { render, staticRenderFns } from "./TheShoe.vue?vue&type=template&id=3d26cab2&scoped=true&"
var script = {}
import style0 from "./TheShoe.vue?vue&type=style&index=0&id=3d26cab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d26cab2",
  null
  
)

export default component.exports